import React from "react";
import { ColorRectangle } from "../components/ColorRectangle";
import { GeneratorPicker } from "../screens/MessageScreen";
import { AppDispatch } from "../../../store";
import { MixState, Target } from "../store/MixReducer";
import { ViewStyle } from "react-native";
import { ButtonFinish, ButtonMix } from "../components/MixButtons";
import { EveColorGuesser, SelectEveKnowledge } from "./messageContents";

export interface Message {
  id?: string; // for check continueAllowed and events
  target?: Target | "eve";
  text?: string;
  content?: string | React.ReactNode;
  customMsgStyles?: ViewStyle;
}

export const messageStore = (
  mix: MixState,
  dispatch: AppDispatch
): Message[] => [
  {
    target: "alice",
    text: "Eyyyy, wie geht's dir in Australien 🇦🇺🏄‍♀️? Bin wieder back in Köln",
  },
  {
    target: "bob",
    text: "Mega, muss so viel erzählen!",
  },
  {
    target: "bob",
    text: "Aber lass mal unsere Übertragung erst verschlüsseln. Grad könnte jeder im Internet unseren Chat mitlesen... 😂",
  },
  {
    target: "alice",
    text: "Jo, lass mit Diffie-Hellmann einen Schlüssel erzeugen, mit dem wir unsere Nachrichten verschlüsseln",
  },
  {
    target: "bob",
    text: "Lass uns dazu fix eine gemeinsame Farbe wählen",
  },
  {
    id: "generator-picker",
    text: "Wähle die Gemeinsame Farbe:",
    content: <GeneratorPicker />,
  },
  {
    id: "alice-has-generator",
    target: "alice",
    text: "Lass das als gemeinsame Farbe nehmen:",
    content: (
      <ColorRectangle color={mix.generator}>Gemeinsame Farbe</ColorRectangle>
    ),
  },
  {
    id: "bob-has-generator",
    target: "bob",
    text: "Top, merke ich mir",
  },
  {
    target: "bob",
    text: "Jetzt erzeugen wir beide jeweils auf unserem eigenen Gerät einen geteilten geheimen Schlüssel",
  },
  {
    target: "bob",
    text: "Der ist wirklich geheim! Den schicken wir uns nichtmal gegenseitig",
  },
  {
    target: "alice",
    text: "Jaja checke, behalte den für mich",
  },
  {
    id: "pick-secrets",
    text: "Wähle für Alice und Bob jeweils ihre geheime Farben (klicke nochmal auf das Feld, um eine neue zu wählen).",
  },
  {
    target: "alice",
    text: "Hab meine private Farbe gewählt",
  },
  {
    target: "bob",
    text: "Hab auch",
  },
  {
    target: "alice",
    text: "Dann lass uns jetzt beide die gemeinsame Farbe mit unserer geheimen Farbe mischen",
  },
  {
    id: "show-mix-button-alice",
    text: "Mische für Alice die gemeinsame Farbe mit ihrer geheimen Farbe:",
    content: <ButtonMix target="alice" />,
  },
  {
    target: "alice",
    text: "Hab gemixt",
  },
  {
    id: "show-mix-button-bob",
    text: "Mische für Bob die gemeinsame Farbe mit seiner geheimen Farbe:",
    content: <ButtonMix target="bob" />,
  },
  {
    target: "bob",
    text: "hab auch gemixt",
  },
  {
    target: "alice",
    text: "Nice, diese Mixe schicken wir uns jetzt - hier meiner:",
  },
  {
    target: "alice",
    content: <ColorRectangle color={mix.alice.mixed}>Alice Mix</ColorRectangle>,
  },
  {
    id: "bob-has-other-mix",
    target: "bob",
    text: "Top, speicher ich mir, hier hast du meinen:",
  },
  {
    target: "bob",
    content: <ColorRectangle color={mix.bob.mixed}>Bob Mix</ColorRectangle>,
  },
  {
    id: "alice-has-other-mix",
    target: "alice",
    text: "Ok hab sie bekommen",
  },
  {
    target: "alice",
    text: "Jetzt mischen wir uns jeder auf unserem eigenen Gerät den geteilten geheimen Schlüssel!",
  },
  {
    id: "show-result-alice",
    text: "Mische für Alice ihre Geheime Farbe + Bobs Mix zur Geteilten Geheimen Farbe.",
    content: <ButtonFinish target="alice" />,
  },
  {
    target: "alice",
    text: "Ok ich hab die Geheime Farbe gemischt",
  },
  {
    id: "show-result-bob",
    text: "Mische für Bob seine Geheime Farbe + Alices Mix zur Geteilten Geheimen Farbe",
    content: <ButtonFinish target="bob" />,
  },
  {
    target: "bob",
    text: "Hab auch",
  },
  {
    target: "bob",
    text: "Cool, fertig! Dann können wir gleich unsere Nachrichten verschlüsseln :D",
  },
  {
    id: "blatt-1-popup",
    target: "bob",
    text: "bin gleich wieder da...",
  },
  {
    text: "Eve hat sich in den Chat dazu gehackt",
  },
  {
    target: "eve",
    text: "Ich habe mich in euren Chat gehackt und sehe alle eure unverschlüsselten Nachrichten.",
  },
  {
    id: "select-eve-knowledge",
    text: "Wähle aus, was Eve alles mitbekommen hat:",
    content: <SelectEveKnowledge mix={mix} dispatch={dispatch} />,
  },
  {
    target: "eve",
    text: "Jetzt werde ich euren Schlüssel hacken, bevor ihr anfangt, alles zu verschlüsseln, weil ich auch wissen will, wie es in Australien war 😲!!!",
  },
  {
    target: "eve",
    text: "Ich glaube, ich brauche eure geheimen Farben gar nicht. Ich mische mir den Schlüssel jetzt einfach selbst! Ich kenne schon:",
    content: (
      <>
        <ColorRectangle color={mix.generator}>Gemeinsame Farbe</ColorRectangle>{" "}
        <ColorRectangle color={mix.alice.mixed}>Alice Mix</ColorRectangle>
        <ColorRectangle color={mix.bob.mixed}>Bob Mix</ColorRectangle>
      </>
    ),
  },
  {
    target: "eve",
    text: "Jetzt versuche ich mal, den Schlüssel selbst herzustellen, indem ich alle Farben durchprobiere:",
  },
  {
    id: "eve-bruteforces",
    text: "Wähle Alice Geheim:",
    content: <EveColorGuesser mix={mix} />,
  },
  {
    target: "eve",
    text: "Mist, 100% genau die richtige Farbe zu wählen, ist echt schwierig, weil es seeeeeehr viele verschiedene Farben gibt. Das dauert bestimmt ewig...",
  },
  {
    target: "alice",
    text: "In Real Life rechnen Computer übrigens mit Zahlen, nicht Farben. Funktioniert aber genauso.",
  },
  {
    target: "bob",
    text: "Cool Story. Ich mache jetzt Aufgabe 2 auf dem Handout. Wenn ich damit fertig bin, schaue ich mir schon mal die Rückseite an.",
  },
  {
    id: "blatt-2-popup",
    target: "alice",
    text: "Bis gleich :)",
  },
];
